import { createTheme, responsiveFontSizes } from '@mui/material/styles';

import overrides from './overrides';
import palette from './palette';
import shape from './shape';
import typography from './typography';

// defaults - https://mui.com/material-ui/customization/breakpoints/
export const breakpointValues = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
}

const theme = responsiveFontSizes(createTheme({
  palette,
  typography,
  components: {
    ...overrides,
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: 'black',
          color: 'white',
          fontSize: '0.9rem'
        }
      }
    },
    MuiAccordion: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          border: 'none',
          background: 'none',
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        outlined: {
          backgroundColor: 'white'
        }
      }
    },
    // MuiAccordionSummary: {
    //   styleOverrides: {
    //     root: {
    //       fontSize: '1.1rem!important'
    //     }
    //   }
    // },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 10
        }
      }
    }
  },
  shape,
  breakpoints: {
    values: breakpointValues,
  },
}))

export default theme